export default __webpack_public_path__ + "static/media/triangle_arrow_left.9fff446e.svg";